import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import store from "./store";
import { Provider } from "react-redux";
import App from "./App";
import NotFound from "./pages/NotFound";

//? ==================================== User Screens Import ====================================
import UserPrivateRoutes from "./pages/User/UserPrivateRoutes";
import UserDashboard from "./pages/User/Dashboard";
import UserLogin from "./pages/User/UserLogin";
import UserRegister from "./pages/User/UserRegister";
import UserProfile from "./pages/User/UserProfile";
import UserPointScreen from "./pages/User/UserPointScreen";
import UserRewardScreen from "./pages/User/UserRewardScreen";
import UserChangePassword from "./pages/User/UserChangePassword";
import UserScanMe from "./pages/User/UserScanMe";
import UserHeader from "./components/UserComponents/UserHeader";
import UserForgetPassword from "./pages/User/UserForgetPassword";
import UserResetPassword from "./pages/User/UserResetPassword";
import UserTermsAndConditions from "./pages/User/UserTermsAndConditions";
import ShopLocations from "./pages/User/ShopLocations";


//? ==================================== Admin Screens Import ====================================
import AdminPrivateRoutes from "./pages/Admin/AdminPrivateRoutes";
import AdminDashboard from "./pages/Admin/Dashboard";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminProfileScreen from "./pages/Admin/AdminProfile";
import RedeemptionByPoints from "./pages/Admin/RedeemptionByPoints";
import RewardManagement from "./pages/Admin/RewardManagement";
import AdminChangePassword from "./pages/Admin/AdminChangePassword";
import UsersManagement from "./pages/Admin/UserManagement";
import AdminAddPoints from "./pages/Admin/AdminAddPoints";
import AdminAddStamps from './pages/Admin/AdminAddStamps';
import RewardRedemption from "./pages/Admin/RewardRedemption";
import RedeemptionByStamps from "./pages/Admin/RedeemptionByStamps";
import AdminNotificationCenter from "./pages/Admin/AdminNotificationCenter";


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      {/* ===================================== User Routes ===================================== */}

      <Route index={true} path="/" element={<UserDashboard />} />
      <Route path="/login" element={<UserLogin />} />
      <Route path="/register" element={<UserRegister />} />
      <Route path="/forget-password" element={<UserForgetPassword />} />
      <Route path="/reset-password" element={<UserResetPassword />} />
      

      {/* USER PRIVATE ROUTES */}
      <Route path="" element={<UserPrivateRoutes />}>
        {/* <Route path="/user/loyalty-dashboard" element={<LoyaltyRewardsDashboard />} /> */}
        <Route path="/" element={<UserHeader />} />
        <Route path="/scan-me" element={<UserScanMe />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/point/:id" element={<UserPointScreen />} />
        <Route path="/reward/:id" element={<UserRewardScreen />} />
        <Route path="/user/change-password" element={<UserChangePassword />} />
        <Route path="/terms-and-conditions" element={<UserTermsAndConditions />} />
        <Route path="/shop-locations" element={<ShopLocations />} />
      </Route>

     {/* ===================================== Admin Routes ===================================== */}
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      {/* <Route path="/admin/register" element={<AdminRegister />} /> */}
      
      
      {/* ADMIN PRIVATE ROUTES */}
      <Route path="" element={<AdminPrivateRoutes />}>
        <Route path="/admin/profile" element={<AdminProfileScreen />} />
        <Route path="/admin/manage-users" element={<UsersManagement />} />
        <Route path="/admin/stamps-redeemption" element={<RedeemptionByStamps />} />
        <Route path="/admin/points-redeemption" element={<RedeemptionByPoints />} />
        <Route path="/admin/manage-reward-redeemed" element={<RewardRedemption />} />
        <Route path="/admin/add-points" element={<AdminAddPoints />} />
        <Route path="/admin/add-stamps" element={<AdminAddStamps />} />
        <Route path="/admin/manage-rewards" element={<RewardManagement />} />
        <Route path="/admin/change-password" element={<AdminChangePassword />} />
        <Route path="/admin/notifications-center" element={<AdminNotificationCenter />} />
      </Route>

      {/* Catch-all route for 404 */}
      <Route path="*" element={<NotFound />} />
    </Route>
  ),
  {
    future: {
      v7_startTransition: true, // Enable React.startTransition behavior
      v7_relativeSplatPath: true, // Enable new relative path resolution behavior
    },
  }
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </Provider>
);